var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseRedFilledBordered({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 75,
    viewBox: "0 0 82 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.9062,
    cy: 37.5,
    r: 37.5,
    fill: "#F44336",
    fillOpacity: 0.26
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.4062 37C68.4062 53.5675 54.9738 67 38.4062 67C21.8387 67 8.40625 53.5675 8.40625 37C8.40625 20.4325 21.8387 7 38.4062 7C54.9738 7 68.4062 20.4325 68.4062 37Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0813 26L48.6163 29.535L30.9413 47.21L27.4062 43.675L45.0813 26Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6163 43.675L45.0813 47.21L27.4062 29.535L30.9413 26L48.6163 43.675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRedFilledBordered);
export default __webpack_public_path__ + "static/media/close-red-filled-bordered.45e7022d9dde15ed7ca18c9280479e41.svg";
export { ForwardRef as ReactComponent };